/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation AccountDelete($accountId: ID!) {
    AccountDelete(accountId: $accountId) {
        message
        status
    }
} 
`

